module.exports = __webpack_public_path__ + "img/business_01.dc41045b.jpg";